export function buildTelaioFromForm(formValue: any, prefix: string, keys: string[]): any {
    return keys.reduce((acc, key) => {
        const formKey = prefix ? `${prefix}${key}` : key;
        acc[key] = formValue[formKey] ?? null;
        return acc;
    }, {} as any);
}

export function flattenTelaio(prefix: string, source?: any, keys: string[] = []): Record<string, any> {
    if (!source) return {};
    return keys.reduce((acc, key) => {
        const val = source[key];
        if (val !== undefined && val !== null) acc[`${prefix}${key}`] = val;
        return acc;
    }, {} as any);
}

export function buildIvObject(formValue: any, currentIv: any, keys: string[]): any {
    const base: any = { id: currentIv?.id ?? null };

    keys.forEach((k) => {
        base[k] = formValue[k] ?? null;
    });

    return base;
}
